<template>
  <div>

    <el-row style="margin-bottom:10px;">
      <el-col :span="18" class='flex'>
        <el-select v-model='theSelectProjectId' v-if="theUserProject==0" clearable size="small" @change="theSelectProjectChange" placeholder="请选择项目">
            <el-option
                v-for="item in getProjectList_data.data||[]"
                :key="item.projectId"
                :label="item.projectName"
                :value="item.projectId">
            </el-option>
        </el-select>
        <el-input
          v-model="getSysRulePointsList_data.businessName"
          placeholder="请输入业务名称"
          clearable
          size='small'
          style="max-width:380px;"/>
        <el-button
          v-click.getSysRulePointsList
          type="primary"
          icon='el-icon-search'
          size='small'
          style='margin-left:10px;'
        >搜索
        </el-button>
        <el-button 
          @click="oneKeyClick"
          size='small'
          type="success"
          style="margin-left: 10px;"
        >一键同步
        </el-button>
      </el-col>
      <el-col :span="6" >
        <el-button v-if="addSysRulePoints && theSelectProjectId"
          @click="toAddSysRulePoints"
          size='small'
          type="primary"
          style="float:right"
          icon='el-icon-circle-plus'
        >添加积分规则
        </el-button>
      </el-col>
    </el-row>

    <mytable
      :tableColums='tableColums_getSysRulePointsList'
      api='getSysRulePointsList'
      xupdateapi='updateSysRulePoints'
      :height="H-165" >
    </mytable>

    <myform
      :viewobj='{
        addSysRulePoints:    [ "新增积分规则信息", "el-icon-circle-plus" ],
        updateSysRulePoints: [ "修改积分规则信息", "el-icon-edit-outline"],
        $succeed$: getSysRulePointsList
      }'
      @close='$form("addSysRulePoints","reset")' >
      <hide slot='srpId' />
      <hide slot='projectId' />

      <template v-slot:projectId="{Myformdata}" >
        <el-select v-model='Myformdata.projectId' disabled @change="projectChange">
            <el-option
                v-for="item in getProjectList_data.data||[]"
                :key="item.projectId"
                :label="item.projectName"
                :value="item.projectId">
            </el-option>
        </el-select>
  	  </template>
       <!-- 类型 -->
      <template v-slot:srpType="{Myformdata}" >
        <el-select v-model='Myformdata.srpType' @change="srpTypeChange">
            <el-option
                v-for="item in theSrpTypeAll"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
        </el-select>
  	  </template>
      <!-- 业务积分类型 -->
      <template v-slot:srpBusinessType="{Myformdata}" >
        <el-select v-model='Myformdata.srpBusinessType' :disabled="Myformdata.srpType!=3" @change="gettype">
            <el-option
                v-for="item in srpBusinessTypeAll"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
        </el-select>
  	  </template>
      <!-- 业务ids -->
      <template v-slot:businessIds="{Myformdata}">
        <el-select v-model='Myformdata.businessIds' :disabled="Myformdata.srpType!=3" :multiple="Myformdata.srpBusinessType==3" >
            <el-option
                v-if="Myformdata.projectId"
                :key="itemOther.businessId"
                :label="itemOther.businessName"
                :value="itemOther.businessId">
            </el-option>
        </el-select>
  	  </template>

      <template v-slot:srpPointsNum="{Myformdata}">
        <el-input v-model="Myformdata.srpPointsNum" :disabled="(Myformdata.srpType ==3 &&  Myformdata.srpBusinessType!=1 && Myformdata.srpBusinessType!=2 )||Myformdata.srpType ==5 || Myformdata.srpType =='' || Myformdata.srpType ==7" type="number" size="small" placeholder="请输入积分数量"></el-input>
  	  </template>

      <template v-slot:srpMultiply="{Myformdata}">
        <el-input v-model="Myformdata.srpMultiply" :disabled="Myformdata.srpType!=3 || Myformdata.srpBusinessType!=3" type="number" size="small" placeholder="请输入倍数"></el-input>
  	  </template>

      <template v-slot:srpMoneyPer ="{Myformdata}">
        <el-input v-model="Myformdata.srpMoneyPer" :disabled="Myformdata.srpType != 5 && Myformdata.srpType != 7 && Myformdata.srpType != 8 &&Myformdata.srpType != 9" type="number" size="small" placeholder="请输入金额比"></el-input>
  	  </template>

      <template v-slot:srpPointsLimit="{Myformdata}">
        <el-input v-model="Myformdata.srpPointsLimit" :disabled="Myformdata.srpType==6||Myformdata.srpType==3||Myformdata.srpType==5||Myformdata.srpType =='' ||Myformdata.srpType==7 || Myformdata.srpType==8 || Myformdata.srpType==9" type="number" size="small" placeholder="请输入当日积分上限"></el-input>
  	  </template>
      <template v-slot:srpMoneyStart="{Myformdata}">
        <el-input v-model="Myformdata.srpMoneyStart" :disabled="Myformdata.srpType!=3||Myformdata.srpBusinessType!=1" type="number" size="small" placeholder="请输入金额范围首"></el-input>
  	  </template>
      <template v-slot:srpMoneyEnd="{Myformdata}">
        <el-input v-model="Myformdata.srpMoneyEnd" :disabled="(Myformdata.srpType!=3 || Myformdata.srpBusinessType!=1) && Myformdata.srpType != 8 &&Myformdata.srpType != 9" type="number" size="small" placeholder="请输入金额范围末"></el-input>
  	  </template>
    </myform>
  </div>
</template>

<script>
export default {
  data() {
    return {
      itemOther:{businessId:0,businessName:"其他业务"},
      theUserProject: "",
      theSelectProjectId: "",
      theSelectSrpType: "",
      theSrpTypeAll:[
          {id:1,name:"打卡"},
          {id:2,name:"开单"},
          {id:3,name:"业务"},
          {id:4,name:"案例分享"},
          {id:5,name:"金额比"},
          {id:6,name:"完成打卡目标"},
           {id:7,name:"年化金额比"},
            {id:8,name:"金额段(前段范围,后段金额比)"},
             {id:9,name:"年化金额段(前段范围,后段金额比)"},

      ],
      srpBusinessTypeAll:[
          {id:1,name:"金额"},
          {id:2,name:"数量"},
          {id:3,name:"倍数"},
      ],

      tableColums_getSysRulePointsList: {
        $selection: false,

        projectName: '项目',

        srpType: ['类型',,'@v-if: 1:打卡#danger, 2:开单#danger, 3:业务, 4:案例分享#danger ,5:金额比#danger ,6:完成打卡目标#danger,7:年化金额比#danger,8:金额段#danger,9:年化金额段#danger'],

        businessName: '业务名称',

        srpPointsNum: '积分数量',

        srpMultiply: '倍数',

        srpPointsLimit: '当日积分上限',

        srpBusinessType: ['业务积分类型',,'@v-if: 1:金额, 2:数量#danger ,3:倍数#danger'],

        srpMoneyPer: '金额比',

        srpMoneyStart: '金额范围首',

        srpMoneyEnd: '金额范围末',

        $operation: [
          '操作', 200,
          this.updateSysRulePoints && `@text: 编辑#success
           @click: $form("updateSysRulePoints",$row),
           updata($row)
          `,
          this.deleteSysRulePoints && `@text: 删除#danger
           @click: _confirm('确定要删除该积分规则吗?')
                   .trigger('deleteSysRulePoints',{srpId:$row.srpId})
                   .trigger('getSysRulePointsList')
          `,
        ],

      },

    };
  },

  watch: {

  },

  methods: {
    oneKeyClick(){
      this.updateSysRulePointsFromParent().result(res =>{
        if(res.data.data){
          this.getSysRulePointsList()
        }
      });
      
    },
     updata(e){
      this.Myformdata.projectId=this.theSelectProjectId
      this.Myformdata.businessIds = parseInt(e.businessIds) ;

      console.log(this.Myformdata.businessIds);
      if(e.srpBusinessType ==3){
        var arr = [];
        var str='['+e.businessIds+']';
        var tem = JSON.parse(str);
        tem.forEach(element => {
          arr.push(element)
        });
        this.Myformdata.businessIds = arr
      }else {
         this.Myformdata.businessIds = ""
      }
    },
    gettype(){
      this.Myformdata.businessIds=''
    },

    toAddSysRulePoints(){
      this.$form('addSysRulePoints');
      this.$nextTick(()=>
        this.Myformdata.projectId=this.theSelectProjectId
      )
    },
    srpTypeChange(e){

      this.Myformdata.srpBusinessType=''

      this.theSelectSrpType=e;
    },
    theSelectProjectChange(e){
        //搜索
        this.theSelectProjectId=e;
        this.getSysRulePointsList({projectId:this.theSelectProjectId});
    },
    projectChange(e){
        //新增编辑
    },
  },

  created() {
    this.theUserProject=A.local('$projectId');
    if(this.theUserProject!=0){
      this.theSelectProjectId=this.theUserProject;
    }
    this.getSysRulePointsList({projectId:this.theSelectProjectId});
    this.getProjectList({ pageSize: 0 });
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/rule/PointsRuleManage.vue